import React from 'react';
import Slider from "react-slick";
import SingleProduct from '../alibrary/SingleProduct';
import SectionTitle from '../../components/Common/SectionTitle';

import shopImg1 from '../../assets/img/publication/1.jpg';
import shopImg2 from '../../assets/img/publication/2.jpg';
import shopImg3 from '../../assets/img/publication/3.jpg';
import shopImg4 from '../../assets/img/publication/4.jpg';
import shopImg5 from '../../assets/img/publication/5.jpg';
import shopImg6 from '../../assets/img/publication/6.jpg';

const Publications = () => {

    const slilderSettings = {
        dots: false,
        centerMode: false,
        infinite: true,
        arrows: true,
        className: "active",
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <React.Fragment>            
            <div className="rs-publication pt-100 pb-100 md-pt-80 md-pb-70">
                <div className="container">
                    <SectionTitle
                        sectionClass="sec-title2 text-center mb-50 md-mb-30"
                        subtitleClass="sub-title primary"
                        subtitle="البحت العلمي"
                        titleClass="title mb-0"
                        title="المجلات العلمية للجامعة"
                    />
                    <Slider {...slilderSettings}>
                        <SingleProduct 
                            title = "University of Zawia Journal of Economic Sciences"
                            image = {shopImg1}
                            Linkto = 'https://journals.zu.edu.ly/index.php/JES'
                           
                        />
                        <SingleProduct 
                            title = "University of Zawia Journal of Engineering Sciences and Technology"
                            image = {shopImg2}
                            Linkto ='https://journals.zu.edu.ly/index.php/UZJEST'
                           
                        />
                        <SingleProduct 
                            title = "University of Zawia Journal of Legal and Sharia Sciences"
                            image = {shopImg3}
                            Linkto = 'https://journals.zu.edu.ly/index.php/Law_Sciences'
                           
                        />
                            <SingleProduct 
                            title = "University of Zawia - Rawak Elhkma Journal"
                            image = {shopImg4}
                            Linkto = 'https://journals.zu.edu.ly/index.php/Rewaq_AlHakam' 
                        />
                              <SingleProduct 
                            title = "University of Zawia Journal of the World of Sports and Educational Sciences"
                            image = {shopImg5}
                            Linkto = 'https://journals.zu.edu.ly/index.php/WSEJ'  
                        />     
                         <SingleProduct 
                        title = "University of Zawia -Faculty of Arts Journal"
                        image = {shopImg6}
                        Linkto = 'https://journals.zu.edu.ly/index.php/ZUFAJ'
                       
                    />
                      
                    </Slider>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Publications;